import { Checkout } from '../types/checkout';
import { MoedaVendaDescricao } from '../types/enums/moeda-venda.enum';
import { buildTtclid, buildTtp } from './tiktok-utils';
import { getUrlParams } from './get-url-params';
import { gerarTokenRecaptcha } from './getReCaptcha';
import { CreatePurchaseContract } from '../types/create-purchase-contract';
import { Api } from '../hooks/useApi';

export type TikTokEventName =
  | 'ViewContent'
  | 'InitiateCheckout'
  | 'AddPaymentInfo'
  | 'Purchase';

export const emitTikTokEvent = async (input: {
  event: TikTokEventName;
  eventId?: string;
  checkout: Checkout;
  data?: CreatePurchaseContract;
  orderId?: string;
}) => {
  const api = new Api();
  try {
    const { event, eventId, checkout, data, orderId } = input;
    const recaptchaToken = await gerarTokenRecaptcha('/produto/tiktok_pixel/id');
    const response = await api.Produto.emitTikTokEvent(checkout?.id, {
      eventName: event,
      eventId: eventId ?? undefined,
      recaptchaToken,
      parametros: {
        event_source_url: `https://checkout.vendepay.com/${checkout?.id}`,
        referrer: typeof document !== 'undefined' ? document.referrer : undefined,
        customData: {
          value: checkout?.valor,
          currency: MoedaVendaDescricao[checkout?.moeda],
        },
        user_data: {
          em: data?.email ? [data.email] : undefined,
          ph: data?.phoneNumber ? [data.phoneNumber] : undefined,
          fn: data?.fullName ? [data.fullName.split(' ')[0]] : undefined,
          ln: data?.fullName
            ? [data.fullName.split(' ').slice(1).join(' ')]
            : undefined,
          external_id: checkout?.externalId ? [checkout.externalId] : undefined,
          ttclid: buildTtclid() ?? undefined,
          ttp: buildTtp() ?? undefined,
        },
        custom_data: {
          value: checkout?.valor,
          currency: MoedaVendaDescricao[checkout?.moeda],
          order_id: orderId,
        },
        utm_source: getUrlParams('utm_source'),
        utm_medium: getUrlParams('utm_medium'),
        utm_campaign: getUrlParams('utm_campaign'),
        utm_content: getUrlParams('utm_content'),
        utm_term: getUrlParams('utm_term'),
      },
    });
    return response.data;
  } catch (e) {
    console.error('Erro no tracking do TikTok:', e);
  }
};
